require("./looks_costume.js");
require("./looks_switchcostumeto.js");
require("./looks_nextcostume.js");
require("./looks_costumenumbername.js");
require("./looks_hidden.js");
require("./looks_visible.js");
require("./looks_show.js");
require("./looks_hide.js");
require("./looks_changesizeby.js");
require("./looks_setsizeto.js");
require("./looks_size.js");
require("./looks_xstretch.js");
require("./looks_ystretch.js");
require("./looks_stretch_to.js");
require("./looks_xstretch_to.js");
require("./looks_ystretch_to.js");
require("./looks_xstretch_by.js");
require("./looks_ystretch_by.js");
require("./looks_seteffectto.js");
require("./looks_change_effect_by.js");
require("./looks_geteffect.js");
require("./looks_zindex_to.js");
require("./looks_zindex_by.js");
require("./looks_zindex.js");
require("./looks_alpha_to.js");
require("./looks_alpha_by.js");
require("./looks_alpha.js");
require("./looks_skew_to.js");
require("./looks_xskew_to.js");
require("./looks_yskew_to.js");
require("./looks_xskew_by.js");
require("./looks_yskew_by.js");
require("./looks_xskew.js");
require("./looks_yskew.js");
require("./looks_costumenames.js");
require("./looks_costumes.js");
